<div class="paginator">
    <span class="paginator__previous" *ngIf="currentPageNumber !== 1" (click)="onClickPrevious()">Previous</span>
    <span class="paginator__pageNumbers_container" *ngFor="let pageNumber of createRange(pageNumbers)">
        <span [ngClass]="{paginator__currentPage: pageNumber === currentPageNumber}" (click)="pageNumber === currentPageNumber ? '' : onClickPageNumber(pageNumber)">{{ pageNumber }}</span>
    </span>
    <span class="paginator__next" *ngIf="!endOfSet" (click)="onClickNext()">Next</span>
</div>


